import script from "./LocalCurico.vue?vue&type=script&setup=true&lang=js"
export * from "./LocalCurico.vue?vue&type=script&setup=true&lang=js"

import "./LocalCurico.vue?vue&type=style&index=0&id=0534efb5&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0534efb5"]])

export default __exports__